import React from 'react';
import { Calendar, Clock, MapPin } from 'lucide-react';
export function FarmVisits() {
  return <section id="visits" className="py-20 bg-green-900 text-white relative overflow-hidden" data-id="element-131">
      <div className="absolute inset-0 opacity-20" data-id="element-132">
        <img src="https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&auto=format&fit=crop&w=1932&q=80" alt="Farm background" className="w-full h-full object-cover" data-id="element-133" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-134">
        <div className="bg-green-950/80 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-green-800 shadow-2xl" data-id="element-135">
          <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-136">
            <div className="w-full md:w-1/2" data-id="element-137">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-138">
                Experience GreenSlopes Farm
              </h2>
              <p className="text-green-100 text-lg mb-8 leading-relaxed" data-id="element-139">
                We welcome visitors to learn about modern dairy farming,
                sustainable agriculture, and our history. Whether you're a
                student, a fellow farmer, or just curious, come see how we do
                things.
              </p>

              <div className="space-y-6" data-id="element-140">
                <div className="flex items-start" data-id="element-141">
                  <div className="bg-green-800 p-3 rounded-lg mr-4" data-id="element-142">
                    <Calendar className="h-6 w-6 text-green-300" data-id="element-143" />
                  </div>
                  <div data-id="element-144">
                    <h4 className="font-bold text-lg" data-id="element-145">By Appointment Only</h4>
                    <p className="text-green-200 text-sm" data-id="element-146">
                      Please book at least 48 hours in advance.
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-147">
                  <div className="bg-green-800 p-3 rounded-lg mr-4" data-id="element-148">
                    <Clock className="h-6 w-6 text-green-300" data-id="element-149" />
                  </div>
                  <div data-id="element-150">
                    <h4 className="font-bold text-lg" data-id="element-151">Visiting Hours</h4>
                    <p className="text-green-200 text-sm" data-id="element-152">
                      Mon-Fri: 9am - 4pm | Sat: 9am - 1pm
                    </p>
                  </div>
                </div>

                <div className="flex items-start" data-id="element-153">
                  <div className="bg-green-800 p-3 rounded-lg mr-4" data-id="element-154">
                    <MapPin className="h-6 w-6 text-green-300" data-id="element-155" />
                  </div>
                  <div data-id="element-156">
                    <h4 className="font-bold text-lg" data-id="element-157">Location</h4>
                    <p className="text-green-200 text-sm" data-id="element-158">
                      Nyandarua County, Kenya
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full md:w-1/2 bg-white rounded-2xl p-8 text-gray-900" data-id="element-159">
              <h3 className="text-2xl font-bold mb-6 text-green-900" data-id="element-160">
                Book a Visit
              </h3>
              <form className="space-y-4" data-id="element-161">
                <div className="grid grid-cols-2 gap-4" data-id="element-162">
                  <div data-id="element-163">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-164">
                      First Name
                    </label>
                    <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none" placeholder="John" data-id="element-165" />
                  </div>
                  <div data-id="element-166">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-167">
                      Last Name
                    </label>
                    <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none" placeholder="Doe" data-id="element-168" />
                  </div>
                </div>
                <div data-id="element-169">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-170">
                    Email
                  </label>
                  <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none" placeholder="john@example.com" data-id="element-171" />
                </div>
                <div data-id="element-172">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-173">
                    Preferred Date
                  </label>
                  <input type="date" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none" data-id="element-174" />
                </div>
                <div data-id="element-175">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-176">
                    Message / Group Size
                  </label>
                  <textarea rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent outline-none" placeholder="We are a group of 5..." data-id="element-177"></textarea>
                </div>
                <button type="button" className="w-full bg-green-600 hover:bg-green-700 text-white font-bold py-3 rounded-lg transition-colors shadow-lg" data-id="element-178">
                  Request Booking
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>;
}